'use client';
import { Button, Modal, Skeleton, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import Image from 'next/image';
import QRCode from 'qrcode';
import { useEffect, useState } from 'react';
import DownloadIcon from '@/icons/download.svg';

type QrcodeProps = {
  url: string;
  name: string;
};

export const Qrcode = ({ url, name }: QrcodeProps) => {
  const [opened, { open, close }] = useDisclosure();
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!opened) {
      return;
    }

    const generateQrCode = async () => {
      const data = await QRCode.toDataURL(url, { width: 300 });
      setDataUrl(data);
    };
    generateQrCode();
  }, [opened, url]);

  const downloadQrCode = (dataUrl: string | null) => {
    if (!dataUrl) {
      return;
    }
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = `${name} QR Code.png`;
    link.click();
  };
  return (
    <>
      <Button variant='transparent' onClick={open}>
        QR code
      </Button>
      <Modal
        size='lg'
        centered
        opened={opened}
        onClose={close}
        title='Share Embed'
        styles={{
          title: {
            fontSize: '20px',
            fontWeight: 700,
          },
        }}
      >
        <Stack align='center'>
          <Text>
            To view this 3D model on your mobile device and in Augmented Reality, scan the QR code with your camera.
          </Text>
          {dataUrl ? (
            <Image alt='qr code' src={dataUrl} unoptimized width={300} height={300} />
          ) : (
            <Skeleton height={300} width={300} />
          )}
          <Button
            variant='default'
            disabled={!dataUrl}
            onClick={() => downloadQrCode(dataUrl)}
            leftSection={<DownloadIcon />}
          >
            Download QR code
          </Button>
        </Stack>
      </Modal>
    </>
  );
};
